'use strict';

angular.module('study.documents')
    .controller('DocumentsController', ['AccountManager', function(AccountManager) {
        var vm = this;

        vm.hasPermission = AccountManager.hasPermission;
    }]);
